import React from "react";
import styles from "./EmployeesTab.module.css";

const EmployeeTable = ({ employees, onEdit, onDelete }) => {
  if (!employees.length) return <div className={styles.empty}>لا يوجد موظفين حتى الآن</div>;

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>الاسم</th><th>الوظيفة</th><th>الهاتف</th>
            <th>الراتب الأساسي</th><th>نسبة العمولة</th>
            <th>تاريخ التعيين</th><th>الحالة</th><th>إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((emp) => (
            <tr key={emp.id}>
              <td>{emp.fullName}</td>
              <td>{emp.jobTitle}</td>
              <td>{emp.phone}</td>
              <td>{emp.baseSalary?.toLocaleString()} ج.م</td>
              <td>{emp.commissionRate}%</td>
              <td>{new Date(emp.hireDate).toLocaleDateString("ar-EG")}</td>
              <td>
                <span className={emp.isActive ? styles.activeBadge : styles.inactiveBadge}>
                  {emp.isActive ? "نشط" : "غير نشط"}
                </span>
              </td>
              <td className={styles.actionsCell}>
                <button className={styles.editBtn} onClick={() => onEdit(emp)}>تعديل</button>
                <button className={styles.deleteBtn} onClick={() => onDelete(emp)}>حذف</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeTable;